var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerImg"},[_c('el-carousel',{staticClass:"swImg",attrs:{"height":"420px","indicator-position":"none"}},_vm._l((_vm.imgList),function(item,index){return _c('el-carousel-item',{key:index,staticClass:"pointer"},[_c('img',{attrs:{"src":item.img},on:{"click":function($event){return _vm.nav(item)}}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }